<header>
  <nav class="navbar navbar-expand-lg navbar-dark">

    <div class="navbar-brand-wrapper">
      <a class="navbar-brand" href="#home" alt="Arkheim - Realms at war!" angulartics2On="click" angularticsAction="logo" angularticsCategory="navigation">
        <img src="./assets/logos/logo.png" height="32px" alt="Arkheim - Realms at war!">
      </a>
    </div>
    <div class="d-flex flex-row order-2 order-lg-3 ml-auto">
      <ul class="m-md-0 ml-md-auto d-none d-md-flex">
        <li class="nav-item d-flex">
          <a class="socialButton" href="https://bit.ly/Arkheim_FB" target="_blank" angulartics2On="click" angularticsAction="openFacebookButtonHeader" angularticsCategory="socialmedia">
            <i class="fab fa-facebook"></i>
          </a>
          <a class="socialButton" href="https://bit.ly/Arkheim_Discord" target="_blank" angulartics2On="click" angularticsAction="openDiscordButtonHeader" angularticsCategory="socialmedia">
            <i class="fab fa-discord"></i>
          </a>
          <a class="socialButton" href="https://bit.ly/Arkheim_YT" target="_blank" angulartics2On="click" angularticsAction="openYouTubeButtonHeader" angularticsCategory="socialmedia">
            <i class="fab fa-youtube"></i>
          </a>
        </li>
      </ul>
      <ul class="navbar-nav">
        <li class="nav-item form-inline login" >
          <login-button angulartics2On="click" angularticsAction="openPopup" angularticsCategory="login"></login-button>
        </li>
      </ul>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target=".multi-collapse" aria-controls="navBar" aria-expanded="false" aria-label="Toggle navigation" angulartics2On="click" angularticsAction="navBarToggler" angularticsCategory="navigation">
        <i class="fas fa-bars"></i>
      </button>
    </div>

    <div class="multi-collapse navbar-collapse collapse order-3 order-lg-2">
      <ul class="navbar-nav " role="navigation" id="inPageNavBar">
        <li class="nav-item first">
          <a class="nav-link text-uppercase" href="#home" angulartics2On="click" angularticsAction="home" angularticsCategory="navigation" >
            <span i18n="Link to Home section@@header.link.Home">Home</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link text-uppercase" href="#races" angulartics2On="click" angularticsAction="races" angularticsCategory="navigation">
            <span i18n="Link to Home section@@header.link.Races">Races</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link text-uppercase" href="#features" angulartics2On="click" angularticsAction="features" angularticsCategory="navigation">
            <span i18n="Link to about section@@header.link.Features" >Features</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link text-uppercase" href="#media" angulartics2On="click" angularticsAction="media" angularticsCategory="navigation">
            <span i18n="Link to about section@@header.link.Media">Media</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link text-uppercase" href="#downloads" angulartics2On="click" angularticsAction="downloads" angularticsCategory="navigation">
            <span i18n="Link to download section@@header.link.Downloads">Downloads</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link text-uppercase" href="https://bit.ly/Arkheim_Discord" angulartics2On="click" angularticsAction="blog" angularticsCategory="navigation">
            <span i18n="Link to discord@@header.link.Discord">Discord</span>
          </a>
        </li>

        <!--
        <li class="nav-item">
          <a class="nav-link text-uppercase" href="#community" angulartics2On="click" angularticsAction="community" angularticsCategory="navigation">
            <span i18n="Link to about section@@header.link.Community">Community</span>
          </a>
        </li>
        -->
      </ul>
    </div>
  <div class="multi-collapse navbar-collapse collapse order-4">
    <ul class="navbar-nav">
      <li class="nav-item divider" *ngIf="!env.settings.preRegOnly"></li>
      <li class="nav-item dropdown language">
        <a class="nav-link dropdown-toggle" href="#" id="selectLanguageButton" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" angulartics2On="click" angularticsAction="selectLanguage" angularticsCategory="language">
          <span class="flag-icon flag-icon-{{flag}}"></span> {{shortLocale}}
        </a>
        <div class="dropdown-menu" aria-labelledby="selectLanguageButton">
          <a class="dropdown-item" href="{{baseUrl}}/en/"><span class="flag-icon flag-icon-us" angulartics2On="click" angularticsAction="EN" angularticsCategory="language"></span> EN</a>
          <a class="dropdown-item" href="{{baseUrl}}/de/"><span class="flag-icon flag-icon-de" angulartics2On="click" angularticsAction="DE" angularticsCategory="language"></span> DE</a>
          <a class="dropdown-item" href="{{baseUrl}}/ru/"><span class="flag-icon flag-icon-ru" angulartics2On="click" angularticsAction="RU" angularticsCategory="language"></span> RU</a>
          <a class="dropdown-item" href="{{baseUrl}}/pl/"><span class="flag-icon flag-icon-pl" angulartics2On="click" angularticsAction="PL" angularticsCategory="language"></span> PL</a>
          <a class="dropdown-item" href="{{baseUrl}}/fr/"><span class="flag-icon flag-icon-fr" angulartics2On="click" angularticsAction="FR" angularticsCategory="language"></span> FR</a>
          <a class="dropdown-item" href="{{baseUrl}}/tr/"><span class="flag-icon flag-icon-tr" angulartics2On="click" angularticsAction="TR" angularticsCategory="language"></span> TR</a>
          <a class="dropdown-item" href="{{baseUrl}}/it/"><span class="flag-icon flag-icon-it" angulartics2On="click" angularticsAction="IT" angularticsCategory="language"></span> IT</a>
          <a class="dropdown-item" href="{{baseUrl}}/pt/"><span class="flag-icon flag-icon-pt" angulartics2On="click" angularticsAction="PT" angularticsCategory="language"></span> PT</a>
          <a class="dropdown-item" href="{{baseUrl}}/cz/"><span class="flag-icon flag-icon-cz" angulartics2On="click" angularticsAction="CZ" angularticsCategory="language"></span> CZ</a>
          <a class="dropdown-item" href="{{baseUrl}}/es/"><span class="flag-icon flag-icon-es" angulartics2On="click" angularticsAction="ES" angularticsCategory="language"></span> ES</a>
        </div>
      </li>
    </ul>
  </div>
  </nav>
</header>
